

import __layout_0 from '/opt/atlassian/pipelines/agent/build/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/Footer.vue'),
'components/ImposterDisplay': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/ImposterDisplay.vue'),
'components/NavBarI18n': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/NavBarNotifications.vue'),
'components/NavbarThemeSwitcher': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/Notification': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/Notification.vue'),
'components/UserProfile': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
